// Historique local des tests : uniquement dans ce navigateur, jamais transmis.
import { safe } from './format';

export interface HistoryEntry {
  at: string;
  server: string;
  serverName: string;
  down: number | null;
  up: number | null;
  latency: number | null;
  jitter: number | null;
  grade: string;
  connectionType: string;
  shareId?: string;
  deleteToken?: string;
}

const KEY = 'mesurio.historique';
const MAX = 200;

export function loadHistory(): HistoryEntry[] {
  return safe(() => JSON.parse(localStorage.getItem(KEY) ?? '[]') as HistoryEntry[], []);
}

export function saveHistory(list: HistoryEntry[]) {
  safe(() => localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))), undefined);
}

export function addHistory(e: HistoryEntry) {
  saveHistory([e, ...loadHistory()]);
}

export function removeHistory(at: string) {
  saveHistory(loadHistory().filter((e) => e.at !== at));
}

export function toCSV(list: HistoryEntry[]): string {
  const head = ['date', 'serveur', 'descendant_mbps', 'montant_mbps', 'latence_ms', 'gigue_ms', 'reactivite', 'type_connexion', 'lien'];
  const esc = (v: unknown) => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[",;\n]/.test(s) ? `"${s.replaceAll('"', '""')}"` : s;
  };
  const rows = list.map((e) =>
    [e.at, e.serverName, e.down, e.up, e.latency, e.jitter, e.grade, e.connectionType, e.shareId ? `${location.origin}/r/${e.shareId}` : ''].map(esc).join(','),
  );
  return [head.join(','), ...rows].join('\n') + '\n';
}

export function download(name: string, content: string, type: string) {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([content], { type }));
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

export const pref = {
  get: (k: string, d = '') => safe(() => localStorage.getItem('mesurio.' + k) ?? d, d),
  set: (k: string, v: string) => safe(() => localStorage.setItem('mesurio.' + k, v), undefined),
};
